import * as React from 'react';
import { Box, Card, Flex, Menu, Text, tabListBehavior, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { formatDataNumber } from "../../../helpers/format-numbers";
import { LoaderCharts } from "../../loaders/loaders";
import DoughnutChart from '../../chart/charts/doughnut';
import '../visao-geral-unidades/visao-geral-unidades.scss';

export interface IVisaoGeralUnidadesState {
    activeTabId: number;
    chartData: any;
    loading: boolean;
}

interface IVisaoGeralUnidadesProps extends WithTranslation {
    metrics: any;
    index: number;
    filter: any;
    collapseCharts: Function;
    collapsed: boolean;
    theme?: string;
}

class VisaoGeralUnidades extends React.Component<IVisaoGeralUnidadesProps, IVisaoGeralUnidadesState> {
    private localize: TFunction;

    constructor(props: IVisaoGeralUnidadesProps) {
        super(props);
        this.localize = this.props.t;

        this.state = {
            activeTabId: 0,
            chartData: {
                labels: [
                    `${this.localize("UnidadesComAtendimento")} (${formatDataNumber(this.props.metrics?.activeUnidades)})`,
                    `${this.localize("UnidadesInativas")} (${formatDataNumber(this.props.metrics?.totalUnidades - this.props.metrics?.activeUnidades)})`,
                ],
                datasets: [
                    {
                        data: [this.props.metrics?.activeUnidades, (this.props.metrics?.totalUnidades - this.props.metrics?.activeUnidades)],
                    }
                ],
            },
            loading: false,
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartData: {
                    labels: [
                        `${this.localize("UnidadesComAtendimento")} (${formatDataNumber(this.props.metrics?.activeUnidades)})`,
                        `${this.localize("UnidadesInativas")} (${formatDataNumber(this.props.metrics?.totalUnidades - this.props.metrics?.activeUnidades)})`
                    ],
                    datasets: [
                        {
                            data: [this.props.metrics?.activeUnidades, (this.props.metrics?.totalUnidades - this.props.metrics?.activeUnidades)],
                        }
                    ],
                }
            })
        }
    }

    public setActiveTabId(index: number, item: any) {
        this.props.filter(parseInt(item.content.split(" ")[0]), index).then((res: any) => this.setState({ loading: false }));

        this.setState({
            activeTabId: index
        })
    }

    public render() {
        return (
            <div className="visao-geral-unidades">
                <Box
                    styles={{
                        display: "grid",
                        gridGap: ".5rem",
                        gridTemplate:
                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                        gridAutoFlow: "dense",
                        gridAutoRows: this.props.collapsed ? "15rem 2rem" : "23rem 2rem",
                        padding: ".5rem",
                        minWidth: "20rem",
                        "@media (max-width: 986px)": {
                            gridTemplate:
                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                        },
                    }}
                >
                    <Card.Header>
                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                            <Flex gap="gap.small" column>
                                <Text content={this.localize("VisaoGeralUnidades")} style={{ margin: 0 }} weight="bold" />
                            </Flex>
                        </Flex>
                    </Card.Header>
                    <Card.Body
                        style={{ overflow: "hidden" }}
                        fitted
                    >
                        {this.props.metrics ?
                            <>
                                <Menu
                                    hidden={this.props.collapsed}
                                    className="tabList"
                                    style={{
                                        border: "none",
                                        background: "none",
                                        marginBottom: "1.25rem",
                                    }}
                                    items={[
                                        {
                                            key: "7",
                                            content: this.localize("7dias")
                                        },
                                        {
                                            key: "30",
                                            content: this.localize("30dias")
                                        },
                                        {
                                            key: "60",
                                            content: this.localize("60dias")
                                        }
                                    ]}
                                    activeIndex={this.props.index}
                                    onItemClick={(currentTarget, props) => {
                                        this.setState({ loading: true });
                                        this.setActiveTabId(props && props.index ? props.index : 0, props);
                                    }}
                                    accessibility={tabListBehavior}
                                    underlined
                                    primary
                                />

                                {this.state.loading ? <LoaderCharts /> :
                                    <Flex gap="gap.medium" column>
                                        <Flex className="chartRelatorioAtendimentos" column>
                                            <FluentUIThemeConsumer
                                                render={(globalTheme) => {
                                                    return (
                                                        <DoughnutChart
                                                            {...{
                                                                title: this.localize("VisaoGeralUnidades"),
                                                                data: this.state.chartData,
                                                                siteVariables: globalTheme.siteVariables,
                                                                customWidth: 400,
                                                                customHeight: 120,
                                                                collapsed: this.props.collapsed,
                                                                theme: this.props.theme
                                                            }}
                                                        />
                                                    )
                                                }}
                                            />

                                            <Flex hAlign="center" className={this.props.collapsed ? "unidadesAtivasCollapsed" : "unidadesAtivas"} column>
                                                <Text size="larger" content={formatDataNumber(this.props.metrics?.activeUnidades)} />
                                                <Text size="smaller" content={this.localize("UnidadesComAtendimento")} />
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                }
                            </>
                            :
                            <svg className="emptyChart" viewBox="0 0 550 550">
                                <rect y="37.7" width="88.7" height="414.6" />
                                <rect x="133.8" y="147.4" width="88.7" height="304.9" />
                                <rect x="267.6" y="235.7" width="88.7" height="216.6" />
                                <rect x="401.3" y="307.2" width="88.7" height="145.1" />
                            </svg>
                        }
                    </Card.Body>
                </Box>
            </div>
        );
    }
}

const visaoGeralUnidadesWithTranslation = withTranslation()(VisaoGeralUnidades);
export default visaoGeralUnidadesWithTranslation;